// import React from 'react'
import {
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const StyledStatus = ({ status }: any) => {
  return (
    <div
      className={
        status == "Available"
          ? "bg-green-600 text-white font-bold p-[2px] w-24 rounded-xl text-center"
          : "bg-red-600 text-white font-bold p-[2px] w-24 rounded-xl text-center"
      }
    >
      {status}
    </div>
  );
};
function DoctorsList({ orders }: any) {
  return (
    <>
        {/* <Scrollbar sx={{ flexGrow: 1 }}> */}
        <div>
        <CardHeader title="All doctors" />
          <Table >
            <TableHead>
              <TableRow >
                <TableCell>Sl no</TableCell>
                <TableCell>Doctor</TableCell>
                <TableCell sortDirection="desc">Time</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order: any, index: any) => {
                return (
                  <TableRow hover key={order?.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Typography component="div">{order.name}</Typography>
                      <Typography sx={{ color: "text.secondary" }}>
                        {order?.department}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1">
                        {" "}
                        {order.time?.startTime} - {order.time?.endTime}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <StyledStatus
                        status={order?.time ? "Available" : "Not Available"}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        {/* </Scrollbar> */}
 
      <Divider />
    </>
  );
}

export default DoctorsList;
